import { RouteRecordRaw } from "vue-router";

const ReportBuilderPage = () => import("@/pages/report-builder/ReportBuilderPage.vue");
const ReportBuilderDashboard = () => import("@/pages/report-builder/ReportBuilderDashboard.vue");
const ReportList = () => import("@/pages/report-builder/ReportList.vue");
const ReportView = () => import("@/pages/report-builder/ReportView.vue");
const ReportCreate = () => import("@/pages/report-builder/ReportCreate.vue");
const TemplateList = () => import("@/pages/report-builder/TemplateList.vue");
const TemplateEditor = () => import("@/pages/report-builder/TemplateEditor.vue");
const TemplatePreview = () => import("@/pages/report-builder/TemplatePreview.vue");

export const reportBuilderRoutes: RouteRecordRaw = {
  name: "reportBuilder",
  path: "/reports/:customerId/report-builder",
  component: ReportBuilderPage,
  props: true,
  meta: {
    authenticated: true,
  },
  children: [
    {
      name: "reportBuilderDashboard",
      path: "",
      component: ReportBuilderDashboard,
      props: true,
      meta: { title: `Report Builder` },
      redirect: { name: "reportBuilderReports" },
      children: [
        // These get rendered inside of the Tabs inside the dashboard router-view
        {
          name: "reportBuilderReports",
          path: "reports",
          component: ReportList,
          props: true,
          meta: { title: `Reports` },
        },
        {
          name: "reportBuilderTemplates",
          path: "templates",
          component: TemplateList,
          props: true,
          meta: { title: `Templates` },
        },
      ],
    },
    // These are rendered in the root router-view on /report-builder
    {
      path: "templates",
      children: [
        {
          name: "reportBuilderTemplateNew",
          path: "new",
          component: TemplateEditor,
          meta: { title: `New Template` },
          props: true,
        },
        {
          name: "reportBuilderTemplateEdit",
          path: ":templateId/edit",
          component: TemplateEditor,
          props: true,
        },
        {
          name: "reportBuilderTemplateCopy",
          path: ":templateId/copy",
          component: TemplateEditor,
          meta: { title: `New Template` },
          props: true,
        },
        {
          name: "reportBuilderTemplatePreview",
          path: ":templateId",
          component: TemplatePreview,
          props: true,
        },
        {
          name: "reportBuilderReportNew",
          path: ":templateId/report/new",
          component: ReportCreate,
          props: true,
          meta: { title: `New Report` },
        },
      ],
    },
    {
      path: "reports",
      children: [
        {
          name: "reportBuilderReportEdit",
          path: ":reportId:/edit",
          component: ReportCreate,
          props: true,
        },
        {
          name: "reportBuilderReportView",
          path: ":reportId",
          component: ReportView,
          props: true,
        },
      ],
    },
  ],
};
